module.exports = __webpack_public_path__ + "img/api-economy-hero-2.5eeed701.svg";